import CircularProgress from 'material-ui/CircularProgress';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { asyncRequest, Entities, fetchById, patch, save, search, TOMCAT_URL } from 'src/common/index';
import { setSliderIndex } from 'src/actions/form';
import FindMyBusRequestsCompanyTable from 'src/components/admin/find-my-bus/components/find-my-bus-requests-company-table';
import FindMyBusRequestsOpenAiTable from 'src/components/admin/find-my-bus/components/find-my-bus-requsts-openai-table';
import FindMyBusActiveFilter from 'src/components/admin/find-my-bus/components/find-my-bus-active-filter';

class FindMyBusRequestModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
            busCompanyResults: [],
            openAIResults: {
                startedFetching: false,
                items: [],
            },
        };
    }

    componentWillMount() {
        this.setState({ startedFetching: true });

        asyncRequest({
            endpoint: `${TOMCAT_URL}api/${Entities.FIND_MY_BUS_REQUEST.repository}/get-company-suggestions/${this.props.id}`,
            method: 'GET',
        })
            .then(response => {
                this.setState({ busCompanyResults: response.json, startedFetching: false });
            })
            .catch(error => {});
    }

    render() {
        const finishedFetching = !this.state.startedFetching;
        const { taskInfo, t } = this.props;

        if (!finishedFetching) return <CircularProgress />;
        return (
            <>
                <div className="col-md-12" style={{ marginBottom: 10 }}>
                    <p>
                        {t('search_requests.from.location')} {taskInfo.taskFrom}
                    </p>{' '}
                    <p>
                        {t('search_requests.to.location')}: {taskInfo.taskTo}
                    </p>{' '}
                    <p>
                        {t('search_requests.from.time')} {taskInfo.fromTime}
                    </p>
                    {taskInfo.note && (
                        <p>
                            {t('find_my_bus.customer_note')}: {taskInfo.note}
                        </p>
                    )}
                    {taskInfo.entity.activeFilter && (
                        <FindMyBusActiveFilter t={t} activeFilter={taskInfo.entity.activeFilter} />
                    )}
                    <button
                        type="button"
                        className="btn btn-xs "
                        title={t('user_functionality.open_in_route_planner')}
                        onClick={() => {
                            asyncRequest(
                                `${TOMCAT_URL}api/${Entities.FIND_MY_BUS_REQUEST.repository}/create-link/${taskInfo.journeyId}`,
                            )
                                .then(response => {
                                    const json = response.json;
                                    if (json && json.url) {
                                        const win = window.open(json.url, '_blank');
                                        if (win != null) win.focus();
                                    }
                                })
                                .catch(error => console.error('Error creating Link', error));
                        }}>
                        <span className="glyphicon glyphicon-info-sign text-info" />
                        {t('user_functionality.open_in_route_planner')}
                    </button>
                </div>

                <div className="col-md-12">
                    <FindMyBusRequestsCompanyTable
                        companies={this.state.busCompanyResults.busfinderCompanies}
                        t={t}
                        taskInfo={taskInfo}></FindMyBusRequestsCompanyTable>
                </div>

                <div
                    className="col-md-12"
                    style={{ justifyContent: 'center', marginBottom: 20, marginTop: 10, display: 'flex' }}>
                    {this.state.openAIResults.items && this.state.openAIResults.items.length === 0 && (
                        <button
                            className="btn"
                            onClick={e => {
                                this.findMoreBusCompanies(e);
                            }}>
                            {t('find_my_bus.find_operators_ai')}
                        </button>
                    )}
                    {this.state.openAIResults.startedFetching && <CircularProgress />}

                    {this.state.openAIResults.items && this.state.openAIResults.items.length > 0 && (
                        <FindMyBusRequestsOpenAiTable
                            companies={this.state.openAIResults.items}
                            taskInfo={taskInfo}
                            t={t}
                        />
                    )}
                </div>
            </>
        );
    }

    findMoreBusCompanies(e) {
        this.setState({
            openAIResults: {
                startedFetching: true,
            },
        });

        asyncRequest({
            endpoint: `${TOMCAT_URL}api/${Entities.FIND_MY_BUS_REQUEST.repository}/get-company-suggestions-chat-gpt/${this.props.id}`,
            method: 'GET',
        })
            .then(response => {
                this.setState({
                    openAIResults: {
                        startedFetching: false,
                        items: response.json,
                    },
                });
                // this.setState({ busCompanyResults: response.json, startedFetching: false });
            })
            .catch(error => {});
    }
}

const mapStateToProps = (state, ownProps) => {};

export default connect(
    mapStateToProps,
    {
        fetchById,
        search,
        patch,
        save,
        setSliderIndex,
    },
    null,
    { withRef: true },
)(FindMyBusRequestModal);
